import {
  ViewEncapsulation, Injectable, Component,
  OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter
} from "@angular/core";

@Component({
  selector: "app-fspbs4866-detail",
  templateUrl: "./fspbs4866-detail.component.html",
  styleUrls: ["./fspbs4866-detail.component.css"]
})
export class Fspbs4866DetailComponent implements OnInit, OnChanges {
  @Input() Item: any = undefined;
  /** 充電電流 */
  charging_current = 0;
  /** 放電電流 */
  discharging_current = 0;
  /** 充電功率 */
  charging_watt = 0;
  /** 放電功率 */
  discharging_watt = 0;
  TotalCellVoltage = 0;
  constructor() { }

  ngOnInit() {
    if (this.Item !== undefined && this.Item.status !== undefined) {
      this.charging_current = this.Item.status.Current > 0 ? Math.abs(this.Item.status.Current) : 0;
      this.discharging_current = this.Item.status.Current < 0 ? Math.abs(this.Item.status.Current) : 0;
      this.charging_watt = this.Item.status.TotalVoltage * this.charging_current;
      this.discharging_watt = this.Item.status.TotalVoltage * this.discharging_current;
      if (this.Item.status !== undefined && this.Item.status.M1 !== undefined && this.Item.status.M2 !== undefined) {
        this.TotalCellVoltage = this.Item.status.M1.V0;
        this.TotalCellVoltage += this.Item.status.M1.V1;
        this.TotalCellVoltage += this.Item.status.M1.V2;
        this.TotalCellVoltage += this.Item.status.M1.V3;
        this.TotalCellVoltage += this.Item.status.M1.V4;
        this.TotalCellVoltage += this.Item.status.M1.V5;
        this.TotalCellVoltage += this.Item.status.M1.V6;
        this.TotalCellVoltage += this.Item.status.M1.V7;
        this.TotalCellVoltage += this.Item.status.M2.V0;
        this.TotalCellVoltage += this.Item.status.M2.V1;
        this.TotalCellVoltage += this.Item.status.M2.V2;
        this.TotalCellVoltage += this.Item.status.M2.V3;
        this.TotalCellVoltage += this.Item.status.M2.V4;
        this.TotalCellVoltage += this.Item.status.M2.V5;
        this.TotalCellVoltage += this.Item.status.M2.V6;
        this.TotalCellVoltage += this.Item.status.M2.V7;
      }

    }
  }
  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (this.Item !== undefined && this.Item.status !== undefined) {
      this.charging_current = this.Item.status.Current > 0 ? Math.abs(this.Item.status.Current) : 0;
      this.discharging_current = this.Item.status.Current < 0 ? Math.abs(this.Item.status.Current) : 0;
      this.charging_watt = this.Item.status.TotalVoltage * this.charging_current;
      this.discharging_watt = this.Item.status.TotalVoltage * this.discharging_current;
      if (this.Item.status !== undefined && this.Item.status.M1 !== undefined && this.Item.status.M2 !== undefined) {
        this.TotalCellVoltage = this.Item.status.M1.V0;
        this.TotalCellVoltage += this.Item.status.M1.V1;
        this.TotalCellVoltage += this.Item.status.M1.V2;
        this.TotalCellVoltage += this.Item.status.M1.V3;
        this.TotalCellVoltage += this.Item.status.M1.V4;
        this.TotalCellVoltage += this.Item.status.M1.V5;
        this.TotalCellVoltage += this.Item.status.M1.V6;
        this.TotalCellVoltage += this.Item.status.M1.V7;
        this.TotalCellVoltage += this.Item.status.M2.V0;
        this.TotalCellVoltage += this.Item.status.M2.V1;
        this.TotalCellVoltage += this.Item.status.M2.V2;
        this.TotalCellVoltage += this.Item.status.M2.V3;
        this.TotalCellVoltage += this.Item.status.M2.V4;
        this.TotalCellVoltage += this.Item.status.M2.V5;
        this.TotalCellVoltage += this.Item.status.M2.V6;
        this.TotalCellVoltage += this.Item.status.M2.V7;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/ESS-BA20GA30IGW/fspbs4866-detail/fspbs4866-detail.component.ts